@use '../../design-tokens/border-radius/border-radius' as *;
@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .container {
    min-width: 180px;
    padding: 12px;
    background: var(--surface-default);
    @include border-radius-r1;
    box-shadow: var(--elevation-strong);
    pointer-events: none;
  }

  .title {
    @include typography-v2-body-xs;
    color: var(--text-soft);
    margin-bottom: 8px;
  }

  .itemsContainer {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    @include typography-v2-body-xs;
  }
}
